import React, { useState } from "react"
import { graphql, StaticQuery } from "gatsby"
import { Typography } from 'antd'
import { css } from "@emotion/core"

import Layout, { Header } from "../components/layout"
import SEO from "../components/seo"
import Colors from "../components/colors"
import RestaurantSearch from "../components/RestaurantSearch"
import Restaurant from "../components/restaurant"
import BackgroundImage from "gatsby-background-image"

const { Title, Text } = Typography;

/**
 * Shuffles array in place. ES6 version
 * @param {Array} a items An array containing the items.
 */
const shuffle = (a) => {
  for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const IndexPage = () => {
  const [results, setResults] = useState(null)

  return(
    <StaticQuery query={graphql`{
      siteSearchIndex {
        index
      }

      heroImage : file(relativePath: { eq: "mural.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }

      cities: allAirtable(filter: {table: {eq: "Cities"}}) {
        edges {
          node {
            data {
              Name
              Neighborhoods
              AirtableID
            }
          }
        }
      }
      neighborhoods: allAirtable(filter: {table: {eq: "Neighborhoods"}}) {
        edges {
          node {
            data {
              Name
              CityName
              AirtableID
            }
          }
        }
      }
      locations: allAirtable(filter: {table: {eq: "Locations"}}) {
        edges {
          node {
            data {
              Name
              RestaurantName
              CityName
              NeighborhoodName
              AirtableID
            }
          }
        }
      }
      restaurants: allAirtable(filter: {table: {eq: "Restaurants"}}) {
        edges {
          node {
            data {
              Name
              Gift_Card_Link
            }
          }
        }
      }
    }
      `}
      render={data => {
        return (
        <Layout noHeader>
          <SEO title="Home" />
          <BackgroundImage
             css={css`
              min-height: 30vmax;
            `}
            fluid={data.heroImage.childImageSharp.fluid}
          >
            <div css={css`
              padding: 0;
              height: 100%;
              width: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              color: ${Colors.darkblue};
              &:before {
                content: "";
                z-index: -100;
                background-color: rgba(255, 255, 255, 0);
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
              }
            `}>
              <div css={css`
                background-color: rgba(255, 255, 255, 0.85);
                width: 100%;
              `}>
                <Header />
              </div>
              <div css={css`
                background-color: rgba(255, 255, 255, 0.97);
                padding: 2rem;
                margin: 3rem;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
              `}>
                <Typography css={css`
                  text-align: center;
                  height: 100%;
                  padding: 3vw;
                  color: inherit;
                `}>
                  <Title css={css`font-family:merriweather; font-weight:bold; color: inherit !important;`}>
                    Support your favorite Tampa Bay restaurants
                  </Title>
                  <div css={css`max-width: 700px; margin-left: auto; margin-right: auto;`}>
                    <Text css={css`font-size: 1rem; color: inherit !important;`}>
                      Help support your favorite restaurants as they reopen with limited dine-in capacity and continue to offer carry-out options. Gift cards are a great way to pre-pay for a date night or family night out in the future while allowing the restaurant to have much needed cash immediately.
                    </Text>
                  </div>
                </Typography>
                <div css={css`min-width: 300px; max-width: 700px; width: 50vw; padding: 1rem;`}>
                  <RestaurantSearch 
                    searchIndex={data.siteSearchIndex.index}
                    cities={data.cities.edges.map(e => e.node.data)}
                    neighborhoods={data.neighborhoods.edges.map(e => e.node.data)}
                    locations={data.locations.edges.map(e => e.node.data)}
                    sendResults={(filteredResults) => setResults(filteredResults)}
                  />
                </div>
              </div>
            </div>
          </BackgroundImage>
          <div css={css`
            background-color: white;
            width: 100%;
            min-height: 80vh;
            padding: 2rem 4rem;
            display: flex;
            flex-wrap: wrap;
            align-items: start;
            justify-content: center;
          `}>
            {
              (results && results.length === 0) &&
              "Nothing found. Try a different search or filters."
            }
            {
              shuffle(data.restaurants.edges)
              .filter((edge) => results && results.includes(edge.node.data.Name))
              .map((edge) => (
                <Restaurant
                  key={edge.node.data.AirtableID}
                  link={edge.node.data.Gift_Card_Link}
                  name={edge.node.data.Name}
                />
              ))
            }
          </div>
        </Layout>
      )}}
    />
  )
}

export default IndexPage
